import { MenuButton, FlexRow } from "@intrasync/react";
import type { ScheduleGridBodyCellProps } from "@intrasync/react";
import StatusCircle from './IFCTracker.StatusCircle';
import { ServiceStore } from '@intrasync/stores';
import { computed } from 'mobx';
// import { injectStores } from "@intrasync/react";

type Status =
  | 'new'
  | 'modeled'
  | 'drawn'
  | 'checked'
  | 'issued for construction';

interface IFCStatus {
  id: number;
  jobNumber: number;
  markNumber: string;
  panelModeled: boolean;
  panelDrawn: boolean;
  panelChecked: boolean;
  rearViewIFC: string;
}

interface IFCTrackerRightBodyCellProps extends ScheduleGridBodyCellProps {
  itemsFromEntity: unknown[];
  ifcStatusStore: ServiceStore;
}

const IFCTrackerRightBodyCell = (props: IFCTrackerRightBodyCellProps) => {
  if (props.itemsFromEntity?.length === 0) {
    return (
      <div
        style={{
          border: '1px solid #eee',
          ...props.style,
          ...props.styles,
        }}
      />
    );
  }
  const { itemsFromEntity } = props;
  // const ifcStatusStore = props.ifcStatusStore;
  const currentMainEntity = itemsFromEntity[0] as {
    controlNumber: string;
    markNumber: string;
    castingDate: string;
    jobNumber: number;
    ifcStatus?: Status;
  };
  // console.log('currentMainEntity', currentMainEntity);

  // const ifcStatus = ifcStatusStore?.entities?.find(
  //   (ifcStatus) =>
  //     (ifcStatus.jobNumber as number) === currentMainEntity.jobNumber &&
  //     ifcStatus.markNumber === currentMainEntity.markNumber
  // );

  // console.log('ifcStatus', ifcStatus);

  const buttonColor = 'transparent';
  // if (itemsFromEntity.length >= 2) {
  //   buttonColor = 'error';
  // }

  const drawingStatus = computed(() => {
    if (!currentMainEntity?.ifcStatus) return 'new';
    const ifcStatus = currentMainEntity.ifcStatus as unknown as IFCStatus;

    if (ifcStatus.rearViewIFC !== '1970-01-01')
      return 'issued for construction';

    if (ifcStatus.panelChecked) return 'checked';

    if (ifcStatus.panelDrawn) return 'drawn';

    if (ifcStatus.panelModeled) return 'modeled';

    return 'new';
  }).get();
  // console.log('drawingStatus', drawingStatus);

  return (
    <div
      style={{
        border: '1px solid #eee',
        ...props.style,
        ...props.styles,
      }}
    >
      <MenuButton
        fullWidth
        color={buttonColor}
        menuStyle={{ padding: 10 }}
        menu={() => {
          return (
            <div>
              <div>
                <b>
                  {`${currentMainEntity?.controlNumber} - ${currentMainEntity?.markNumber}`}{' '}
                  Details:
                </b>
                <div>
                  <p>
                    <b>Panel Type:</b> Precast Concrete
                  </p>
                  <p>
                    <b>Dimensions:</b> 10ft x 20ft
                  </p>
                  <p>
                    <b>Weight:</b> 5000 lbs
                  </p>
                  <p>
                    <b>Manufacturer:</b> Concrete Co.
                  </p>
                  <p>
                    <b>Installation Date:</b> {currentMainEntity?.castingDate}
                  </p>
                </div>
              </div>
            </div>
          );
        }}
      >
        <FlexRow>
          <StatusCircle status={drawingStatus} />
          {currentMainEntity && (
            <>
              <div>
                <b>{`${currentMainEntity?.markNumber}`}</b>
              </div>
            </>
          )}{' '}
          {itemsFromEntity.length >= 2 && (
            <div>
              <b>{` (${itemsFromEntity.length}x) `}</b>
            </div>
          )}
        </FlexRow>
      </MenuButton>
    </div>
  );
};

export default IFCTrackerRightBodyCell;
